import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { onError } from "apollo-link-error";
import { from } from 'apollo-link'
import * as Sentry from "@sentry/vue";
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

// Set graphql api end point
const httpLink = new HttpLink({
    uri: '/api/graphql/json',
})

const errorHandler = onError(({graphQLErrors, networkError, operation}) => {
    if (graphQLErrors)
        graphQLErrors.forEach(({message, locations, path, extensions}) => {
                Sentry.withScope(scope => {
                    scope.setExtra("Message", message)
                    scope.setExtra("Locations", locations)
                    scope.setExtra("Path", path)
                    scope.setExtra("Extensions", extensions)
                    scope.setExtra("OperationObject", operation)
                    scope.setExtra("OperationString", operation.query.loc.source.body)
                    Sentry.captureMessage('graphQLErrors: ' + message)
                });
            }
        );
    if (networkError) {
        Sentry.withScope(scope => {
            scope.setExtra("Status Code", networkError.statusCode)
            scope.setExtra("BodyText", networkError.bodyText)
            scope.setExtra("GraphQLResponse", networkError.response)
            scope.setExtra("Stack", networkError.stack)
            scope.setExtra("Message", networkError.message)
            scope.setExtra("Name", networkError.name)
            scope.setExtra("OperationObject", operation)
            scope.setExtra("OperationString", operation.query.loc.source.body)
            Sentry.captureException(networkError)
        });
    }
});

// Create the apollo client
const apolloClient = new ApolloClient({
    // Order matters
    link: from([errorHandler, httpLink]),
    cache: new InMemoryCache(),
    connectToDevTools: true,
})

const apolloProvider = new VueApollo({
    defaultClient: apolloClient
})

Vue.use(VueApollo)

export default apolloProvider
